export const enum HttpMethod {
  GET = "get",
  POST = "post",
  PUT = "put",
  PATCH = "patch",
  DELETE = "delete",
}

export const DEFAULT_HTTP_TIMEOUT_MS = 10000;
